import React from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight, FaTools } from 'react-icons/fa';
import ManpowerServices from '../../components/services/ManPower';
import RentalTerms from '../../components/services/Services';
import ServicesRent from '../../components/services/ServicesRent';
import FaqSection from '../../components/about/FAQ';
import { useNavigate } from 'react-router-dom';
const ManpowerSupply = () => {
  const { language } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const translations = {
    gb: {
      heroContent: {
        title: 'Manpower Supply',
        subtitle: 'Services',
        description: 'Get the right manpower for your job – on time, every time. Professional workforce with flexible hiring terms.',
        buttonText: 'Get in Touch',
      },
    },
    sa: {
      heroContent: {
        title: 'توفير العمالة',
        subtitle: 'الخدمات',
        description: 'احصل على القوى العاملة المناسبة لعملك - في الوقت المحدد، في كل مرة. قوى عاملة محترفة بشروط توظيف مرنة.',
        buttonText: 'تواصل معنا',
      },
    },
    fr: {
      heroContent: {
        title: 'Fourniture de main-d\'œuvre',
        subtitle: 'Services',
        description: 'Obtenez la main-d\'œuvre adaptée à votre projet – à temps, à chaque fois. Personnel professionnel avec des conditions d\'embauche flexibles.',
        buttonText: 'Contactez-nous',
      },
    },
    de: {
      heroContent: {
        title: 'Arbeitskräftebereitstellung',
        subtitle: 'Dienstleistungen',
        description: 'Holen Sie sich die richtigen Arbeitskräfte für Ihren Auftrag – pünktlich, jedes Mal. Professionelle Arbeitskräfte mit flexiblen Anstellungsbedingungen.',
        buttonText: 'Kontaktieren Sie uns',
      },
    },
  };

  const t = translations[language] || translations.gb;

  return (
    <>
      <section 
        className="equipment-rental-hero py-5" 
        style={{ background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)' }}
      >
        <div className="container h-100 px-3">
          <div className="row justify-content-center align-items-center text-center h-100">
            <div className="col-md-8">
              <FaTools className="me-3 text-danger" size={30} aria-hidden="true" />
              <h1 className="mb-3 fw-bold display-4 display-md-3 display-lg-2">
                {t.heroContent.title}
                <div className="d-flex justify-content-center mt-2">
                  <div style={{ width: '40px', height: '3px', backgroundColor: '#c8102e' }}></div>
                  <div style={{ width: '5px', height: '3px', backgroundColor: '#c8102e', margin: '0 4px' }}></div>
                  <div style={{ width: '40px', height: '3px', backgroundColor: '#c8102e' }}></div>
                </div>
              </h1>
              <h3 className="mb-4" style={{ color: '#EF4444' }}>
                {t.heroContent.subtitle}
              </h3>
              <p className="mb-4" style={{ color: '#000' }}>
                {t.heroContent.description}
              </p>
              <button
                className="btn btn-primary mt-3 btn-hover mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
                onClick={() => navigate('/contact')}
              >
                {t.heroContent.buttonText}
                <FaArrowRight className="btn-arrow" />
              </button>
            </div>
          </div>
        </div>

        <style>{`
          .btn-hover:hover .btn-arrow {
            transform: translateX(3px);
          }
          .btn-hover:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }
        `}</style>
      </section>

      <ManpowerServices />
      <RentalTerms />
      <ServicesRent />
      <FaqSection />
    </>
  );
};

export default ManpowerSupply;